/** Saves `blob` to the user's device as `fileName` via a temporary object URL. */
export const downloadBlob = (blob: Blob, fileName: string): void => {
  const objectUrl = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = objectUrl;
  a.download = fileName;
  a.rel = "noopener";
  document.body.appendChild(a);
  a.click();
  a.remove();
  // Defer revoke — revoking synchronously after click can cancel the download.
  setTimeout(() => URL.revokeObjectURL(objectUrl), 4000);
};
